import { render } from "./Competencies.vue?vue&type=template&id=6911e280&scoped=true"
import script from "./Competencies.vue?vue&type=script&lang=js"
export * from "./Competencies.vue?vue&type=script&lang=js"

import "./Competencies.vue?vue&type=style&index=0&id=6911e280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6911e280"]])

export default __exports__